import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14eac6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-testid": "profile-creation-details-experience-level-block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "experienceLevel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.experience.title')), 1),
    _createElementVNode("div", {
      class: "profile-creation-details-experience-level__title",
      innerHTML: _ctx.$icu('profile.creation.completion.wizard.details.job.subtitle', {jobTitle: _ctx.jobTitle})
    }, null, 8, _hoisted_2),
    _createVNode(_component_joy_selectable_item_group, {
      value: _ctx.selectedExperienceLevel,
      "full-width": "",
      onJoySelectableItemGroupChange: _ctx.selectExperienceLevel
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experienceLevels, (experienceLevel) => {
          return (_openBlock(), _createBlock(_component_joy_selectable_item, {
            key: experienceLevel,
            value: experienceLevel,
            "data-testid": _ctx.experienceLevelId(experienceLevel),
            checked: _ctx.isSelectedLevel(experienceLevel)
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getExperienceLevelContent(experienceLevel).label), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.getExperienceLevelContent(experienceLevel).description), 1)
            ]),
            _: 2
          }, 1032, ["value", "data-testid", "checked"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "onJoySelectableItemGroupChange"])
  ]))
}